(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uf-melb-voucher-activation-form"] && !window.DesignMode) return;
  try {
    
  // <script>

  (function () {
    var GCR = {
      handleErrors: function (errors) {
        errors.forEach(function (element) {
          switch (element.field) {
            case 'code':
              var codeInput = document.getElementById('codeField');
              codeInput.classList.add('fieldError');

              // var codeSpan = document.getElementById('redemptionFormCodeError');
              // codeSpan.textContent = element.message;
              var codeDiv = document.getElementById('redemptionFormCodeError');
              codeDiv.innerHTML = element.message;

              break;
            case 'email':
              var emailInput = document.getElementById('emailField');
              emailInput.classList.add('fieldError');

              var emailDiv = document.getElementById('redemptionFormEmailError');
              emailDiv.innerHTML = element.message;
              break;
            case 'phone':
              var phoneInput = document.getElementById('phoneField');
              phoneInput.classList.add('fieldError');

              var phoneDiv = document.getElementById('redemptionFormPhoneError');
              phoneDiv.innerHTML = element.message;
              break;
          }
        });
      },

      removeErrors: function () {
        var codeInput = document.getElementById('codeField');
        var emailInput = document.getElementById('emailField');
        var phoneInput = document.getElementById('phoneField');
        codeInput.classList.remove('fieldError');
        emailInput.classList.remove('fieldError');
        phoneInput.classList.remove('fieldError');

        var codeDiv = document.getElementById('redemptionFormCodeError');
        var emailDiv = document.getElementById('redemptionFormEmailError');
        var phoneDiv = document.getElementById('redemptionFormPhoneError');
        codeDiv.innerHTML = '';
        emailDiv.innerHTML = '';
        phoneDiv.innerHTML = '';
      },

      handleSuccess: function (res, code) {
        var successSpan = document.getElementById('redemptionFormSuccessSpan');
        successSpan.style.display = 'block';
      },

      formSubmit: function (event) {
        event.preventDefault();

        var submitButton = document.getElementById('redeem_voucher_button');
        submitButton.setAttribute('disabled', true);

        GCR.removeErrors();

        var form = document.getElementById('redemptionForm');
        var formData = new FormData(form);
        var url = form.action;
        var options = {
          method: form.method,
          body: JSON.stringify({
            code: document.querySelector('input[name="code"]').value,
            recipientName: document.querySelector('input[name="recipientName"]').value,
            email: document.querySelector('input[name="email"]').value,
            phone: document.querySelector('input[name="phone"]').value,
            emailOptIn: document.querySelector('input[name="emailOptIn"]').checked,
          }),
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        };

        fetch(url, options)
          .then((res) => res.json())
          .then((res) => {
            submitButton.removeAttribute('disabled');
            if (res.error === true) {
              GCR.handleErrors(res.errors);
            } else {
              GCR.handleSuccess(res, document.querySelector('input[name="code"]').value);
            }
          })
          .catch((error) => {
            submitButton.removeAttribute('disabled');
            console.log('ERROR: ', error);
            alert('Something went wrong, please try again later');
          });
      },

      addEventListeners: function () {
        document.getElementById('redemptionForm').addEventListener('submit', GCR.formSubmit);
      },

      init: function () {
        GCR.addEventListeners();
      },
    };

    GCR.init();
  })();

  // </script>

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uf-voucher-activation-form"]) return;
  try {
    
    // <script>
  
    (function () {
      var GCR = {
        handleErrors: function (errors) {
          errors.forEach(function (element) {
            switch (element.field) {
              case 'code':
                var codeInput = document.getElementById('codeField');
                codeInput.classList.add('fieldError');
  
                // var codeSpan = document.getElementById('redemptionFormCodeError');
                // codeSpan.textContent = element.message;
                var codeDiv = document.getElementById('redemptionFormCodeError');
                codeDiv.innerHTML = element.message;
  
                break;
              case 'email':
                var emailInput = document.getElementById('emailField');
                emailInput.classList.add('fieldError');
  
                var emailDiv = document.getElementById('redemptionFormEmailError');
                emailDiv.innerHTML = element.message;
                break;
              case 'phone':
                var phoneInput = document.getElementById('phoneField');
                phoneInput.classList.add('fieldError');
  
                var phoneDiv = document.getElementById('redemptionFormPhoneError');
                phoneDiv.innerHTML = element.message;
                break;
            }
          });
        },
  
        removeErrors: function () {
          var codeInput = document.getElementById('codeField');
          var emailInput = document.getElementById('emailField');
          var phoneInput = document.getElementById('phoneField');
          codeInput.classList.remove('fieldError');
          emailInput.classList.remove('fieldError');
          phoneInput.classList.remove('fieldError');
  
          var codeDiv = document.getElementById('redemptionFormCodeError');
          var emailDiv = document.getElementById('redemptionFormEmailError');
          var phoneDiv = document.getElementById('redemptionFormPhoneError');
          codeDiv.innerHTML = '';
          emailDiv.innerHTML = '';
          phoneDiv.innerHTML = '';
        },
  
        handleSuccess: function (res, code) {
          var successSpan = document.getElementById('redemptionFormSuccessSpan');
          successSpan.style.display = 'block';
        },
  
        formSubmit: function (event) {
          event.preventDefault();
  
          var submitButton = document.getElementById('redeem_voucher_button');
          submitButton.setAttribute('disabled', true);
  
          GCR.removeErrors();
  
          var form = document.getElementById('redemptionForm');
          var formData = new FormData(form);
          var url = form.action;
          var options = {
            method: form.method,
            body: JSON.stringify({
              code: document.querySelector('input[name="code"]').value,
              recipientName: document.querySelector('input[name="recipientName"]').value,
              email: document.querySelector('input[name="email"]').value,
              phone: document.querySelector('input[name="phone"]').value,
              emailOptIn: document.querySelector('input[name="emailOptIn"]').checked,
            }),
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          };
  
          fetch(url, options)
            .then((res) => res.json())
            .then((res) => {
              submitButton.removeAttribute('disabled');
              if (res.error === true) {
                GCR.handleErrors(res.errors);
              } else {
                GCR.handleSuccess(res, document.querySelector('input[name="code"]').value);
              }
            })
            .catch((error) => {
              submitButton.removeAttribute('disabled');
              console.log('ERROR: ', error);
              alert('Something went wrong, please try again later');
            });
        },
  
        addEventListeners: function () {
          document.getElementById('redemptionForm').addEventListener('submit', GCR.formSubmit);
        },
  
        init: function () {
          GCR.addEventListeners();
        },
      };
  
      GCR.init();
    })();
  
    // </script>
  
  } catch(e) { console.error(e); }
})();
})();
